import { ResourceInterface } from '../../domain/interface/resource_interface';
import { ResourceRepository } from '../../domain/repository/resource_repository';
import { ResourceApiService } from '../data_source/resource_api_service';

export class ResourceRepositoryImpl implements ResourceRepository {
  private resourceApiService: ResourceApiService;

  constructor() {
    this.resourceApiService = new ResourceApiService();
  }

  async getResourceByThemeId(id: string): Promise<ResourceInterface[]> {
    const response = await this.resourceApiService.getResourceByThemeId(id);
    return response.data;
  }

  async getResourceById(id: string): Promise<ResourceInterface> {
    const response = await this.resourceApiService.getResourceById(id);
    return response.data;
  }
}
